















import {Component, Prop, Vue} from "vue-property-decorator";
import JsonViewer from 'vue-json-viewer'
import DetailedView from "@/valchrom/views/dataset/DetailedView.vue";

@Component({
    components: {
        JsonViewer,
        VisualComponent: () => import("@/valchrom/views/mathservice/dataset/overview/VisualComponent.vue"),
        DetailedView
    }
})
export default class GraphComponent extends Vue {

    to_svg_data_uri(data: string) {
        return 'data:image/svg+xml;base64,'+window.btoa(unescape(encodeURIComponent(data)));
    }

    @Prop() model: any;
}
